import { useState } from "react";
import { ImageLink } from "../../utils/constants";
import dateformate from "../../helper/DateFormate";
import StatusBadge from "../../Components/StatusBadge";

const AbandonedCartTable = ({ detail }) => {
 const [openRow, setOpenRow] = useState(null);

 const toggleRow = (id) => {
  setOpenRow(openRow === id ? null : id);
 };

 return (
  <div className="card-body p-0">
   <div className="table-responsive">
    <table className="table align-middle mb-0">
     <thead
      style={{
       background: "#f9fafb",
       fontSize: "14px",
      }}
     >
      <tr>
       <th className="ps-4">#</th>
       <th>Image</th>
       <th>Name</th>
       <th>SKU</th>
       <th>Type</th>
       <th>Qty</th>
       <th>Price</th>
       <th>Date</th>
       <th></th>
      </tr>
     </thead>

     <tbody>
      {detail?.abandonedCarts?.length > 0 ? (
       detail.abandonedCarts.map((cart, index) => (
        <>
         <tr key={cart.id} className="table-row">
          <td className="ps-4 fw-semibold">{index + 1}</td>

          <td>
           <img
            src={ImageLink(cart.image)}
            alt=""
            style={{
             width: "100px",
             height: "100px",
             objectFit: "cover",
             objectPosition: "top center",
             borderRadius: "6px",
             border: "1px solid #eee",
            }}
           />
          </td>

          <td>
           <span className="fw-semibold text-dark">{cart.productName}</span>
          </td>

          <td>
           <span className="fw-semibold text-dark">{cart.sku}</span>
          </td>

          <td>
           <StatusBadge status={cart.type} />
          </td>

          <td>
           <span className="text-dark">{cart.quantity}</span>
          </td>
          <td>
           <span className="text-dark">{cart.price}</span>
          </td>

          <td>
           <small className="text-dark">{dateformate(cart.createdAt)}</small>
          </td>

          <td>
           {cart.type === "CATALOGUE" && (
            <button
             className="btn btn-sm btn-primary"
             onClick={() => toggleRow(cart.id)}
            >
             {openRow === cart.id ? "Hide Products" : "View Products"}
            </button>
           )}
          </td>
         </tr>
         {cart.type === "CATALOGUE" && openRow === cart.id && (
          <tr>
           <td colSpan="12" className="bg-light">
            <div className="p-1">
             <div>
              {cart.catalogueProducts?.length > 0 ? (
               cart.catalogueProducts.map((p, i) => (
                <div
                 key={i}
                 className="d-flex justify-content-between align-items-center border rounded p-2 mb-2"
                 style={{ background: "#fff" }}
                >
                 <div
                  className="d-flex align-items-center"
                  style={{ gap: "20px" }}
                 >
                  <img
                   src={ImageLink(p.image?.[0])}
                   alt=""
                   style={{
                    width: "50px",
                    height: "50px",
                    objectFit: "cover",
                    objectPosition: "top center",
                    borderRadius: "6px",
                    border: "1px solid #eee",
                   }}
                  />
                  <div className="d-flex flex-column" style={{ gap: "10px" }}>
                   <span className="fw-semibold">{p.name}</span>
                   <small className="text-muted">SKU: {p.sku}</small>
                  </div>
                 </div>
                 <div className="fw-bold">{p.price}</div>
                </div>
               ))
              ) : (
               <p className="text-muted">No products found</p>
              )}
             </div>
            </div>
           </td>
          </tr>
         )}
        </>
       ))
      ) : (
       <tr>
        <td colSpan="7" className="text-center py-5 text-muted">
         No abandoned carts found
        </td>
       </tr>
      )}
     </tbody>
    </table>
   </div>
  </div>
 );
};

export default AbandonedCartTable;
